import * as React from 'react';
import { SvgIcon } from '../../../WebGiving/components/svg-icon';
import goOnlineIcon from '../../../WebGiving/assets/svg/mobile-gift.svg';
import * as style from './payer-onboarding-info-banner.less';
import { Link } from '../../../WebGiving/primitives/link/link';
import { PayerOnboardingUserAction } from '../../payer-onboarding-user-actions';
import { ModalType } from '../../modals/modal-type';

export class PayerOnboardingInfoBanner extends React.Component<{ raiseAction: (action: PayerOnboardingUserAction) => void }> {
	render() {
		return (
			<div className={style.infoBanner}>
				<SvgIcon svg={goOnlineIcon} className={style.infoBannerIcon}/>
				<div className={style.infoBannerTitle}>Keep things simple</div>
				<div className={style.infoBannerText}>
					Create your account for easy access. <Link className={style.infoBannerLink} acceptanceTestTargetId="Learn more" onClick={this.showLearnMore} branded={true}>
						Learn more.
					</Link>
				</div>
			</div>
		);
	}

	private showLearnMore = (event: React.MouseEvent<HTMLAnchorElement>) => {
		event.preventDefault();
		this.props.raiseAction(new PayerOnboardingUserAction.OpenModalDialog(ModalType.LearnMore));
	}
}
